// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"90":"5f9fb628","161":"5f9fb628","4955":"ff4714b3","7282":"6b4c29cf"}[chunkId] + ".chunk.css";
};